import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/_shared/shared.service';

@Component({
  selector: 'app-admin-settings',
  templateUrl: './admin-settings.component.html',
  styleUrls: ['./admin-settings.component.scss']
})
export class AdminSettingsComponent implements OnInit {

  activeTab = 1;

  tabVehicleTypes = {
    refreshUrl: 'vehicle-types-admin/list',
    detailUrl: 'admin/settings/vehicle-types',
    detailId: 'id_vehicle_type',
    cols: [
      { type: 'text', attr: 'name', header: 'Název' },
      { type: 'number', attr: 'avg_charging_power_kw', suffix: ' kW', header: 'Průměrný výkon' },
      { type: 'number', attr: 'sort_order', header: 'Pořadí' },
      { type: 'bool', attr: 'is_active', header: 'Aktivní' }
    ]
  };

  constructor(public shared: SharedService, private router: Router) { }

  ngOnInit(): void {
    this.activeTab = this.shared.loadActiveTab('rep_admin_settings_tab', false, 1);
  }

  onTabChange(): void {
    this.shared.saveActiveTab('rep_admin_settings_tab', false, this.activeTab);
  }

  addVehicleType(): void {
    this.router.navigate(['/admin/settings/vehicle-types/new']);
  }
}
